import Magnetic from '../Components/Magnetic';

import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'

export const IconData = [
  {icon:"ri-instagram-line",
   link:"https://www.instagram.com/zaid_rehman_05/#"
  },
  {icon:"ri-twitter-line",
   link:"/"
  },
  {icon:"ri-linkedin-fill",
   link:"https://www.linkedin.com/in/zaid-rehman-3bb37529a/"
  },
  {icon:"ri-github-line",
   link:"/"
  },
  {
    icon:"ri-telegram-2-line",
    link:"/"
  },
  {icon:'ri-facebook-fill',
  link:"/"
  }

  
]
const ContactInfo = () => {
  
 

  return (
    <div className='contact sm:h-[100vh] h-[90vh] w-full  flex flex-col  sm:gap-8 gap-6 items-center justify-center text-gray-400'>
<h1 className='relative text-gray-400 sm:text-[2vw] text-[5vw] text-center mb-6'>lets work together
<span className='absolute -bottom-3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-zinc-500 to-transparent '></span>
      </h1>

      <p className='sm:text-[3vw] text-[3.7vw] font-bold text-wrap bg-gradient-to-r from-[#111111] via-gray-400 to-transparent   animate-gradient bg-[length:200%] bg-clip-text text-transparent'><a href='mailto:zaidcodes.404@gmail.com'>zaidcodes.404@gmail.com</a></p>
      <p className='text-zinc-400 sm:text-[1vw] text-[2.4vw]'>Contact me at <a href='tel:9411903629'>9411903629</a></p>

<div className='flex flex-wrap gap-6 items-center justify-center sm:w-full w-[70%]'>
{
    IconData.slice(0,4).map((item, index) => {
    return (
      <Magnetic key={index} icon={item.icon} link={item.link}/>
    ) 
    })
  }
</div>
   
    </div>
  )
}

export default ContactInfo
